<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="custom-shadow-card-header" ref="modaltype">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <br />
        <div class="row">
          <div class="col-12">
            <span style="font-size: 15px; word-break: break-word">
              {{ $t('fertilization.fertilizer_budgeted_info') }}
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            <el-table
              class="table-custom-padding"
              style="width: 100%"
              :data="tableFormData"
              :border="true"
            >
              <el-table-column
                :label="$t('fertilization.fertilizer')"
                prop="fertilizer"
                min-width="130"
                fixed
              >
              </el-table-column>
              <el-table-column label="Cantidad de bultos por ciclo">
                <el-table-column
                  v-for="(column, index) in tableColumns"
                  :key="`${index}`"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                >
                  <template slot-scope="props">
                    <el-input
                      clearable
                      v-if="!showView"
                      size="small"
                      style="text-align: center"
                      v-model="inputs[props.$index + '-' + index]"
                    >
                    </el-input>
                    <span slot-scope="props" v-else>
                      {{ inputs[props.$index + '-' + index] }}
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                :label="$t('common_words.total')"
                min-width="100"
                fixed="right"
              >
                <template slot-scope="props">
                  <strong>
                    {{ formatMoney(calculateTotal(props.$index)) }}
                  </strong>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('common_words.recommended')"
                min-width="130"
                fixed="right"
              >
                <template slot-scope="props">
                  <strong> {{ formatMoney(props.row.recommended) }} </strong>
                </template>
              </el-table-column>
            </el-table>
            <div class="row" v-show="errorAlert">
              <div class="col-lg-12">
                <br />
                <el-alert
                  ref="error_alert"
                  :label="$t('common_words.errors')"
                  type="error"
                  >{{ error }}</el-alert
                >
              </div>
            </div>
            <hr />
            <div class="text-center" v-if="!showView">
              <button
                class="btn btn-fill btn-info btn-wd shadow-sm"
                @click="validateForm"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { showContinue } from 'src/util/Util.js';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      title: '',
      budgetedCardScheduleForm: {},
      tableColumns: [],
      tableFormData: [],
      errorAlert: false,
      error: null,
      showView: false,
      inputs: {},
    };
  },
  mixins: [mixinMasters, MixinPermissions, MixinMenu],
  methods: {
    formatMoney(value) {
      return Formatter.formatMoney(value);
    },

    validateForm() {
      let val = true;

      for (let index = 0; index < this.tableFormData.length; index++) {
        if (
          this.calculateTotal(index) != this.tableFormData[index].recommended
        ) {
          val = false;
        }
      }

      if (!val) {
        this.showError(
          '',
          '',
          i18n.t('show_notification.fertilization.total_recommended_value')
        );
      } else {
        this.budgetedCardScheduleForm.tableFormData = this.tableFormData;
        this.storeUpdateBudgetedCardSchedule();
      }
    },

    calculateTotal(index) {
      let total = 0;

      for (const key in this.inputs) {
        let split = key.split('-');
        if (split[0] == index) {
          if (this.inputs[key] != null && this.inputs[key] > 0) {
            total += parseFloat(this.inputs[key]);
          }
        }
      }

      return total;
    },

    storeUpdateBudgetedCardSchedule() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.budgetedCardScheduleForm.inputs = Object.assign({}, this.inputs);
        this.budgetedCardScheduleForm.route =
          'fertilization/budgeted_card_schedules';

        Axios.saveMaster(this.budgetedCardScheduleForm)
          .then((response) => {
            this.showHideLoading();
            showContinue(
              this,
              response.data.message ? response.data.message : response.errors,
              '/fertilization/budgeted_card_schedules',
              'budgetedCardScheduleForm',
              false
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      if (sessionStorage.getItem('createEditForm')) {
        this.budgetedCardScheduleForm = JSON.parse(
          sessionStorage.getItem('createEditForm')
        );
        this.inputs = this.budgetedCardScheduleForm.inputs;
        this.tableColumns =
          this.budgetedCardScheduleForm.fertilization_cycles_columns;
        this.tableFormData = this.budgetedCardScheduleForm.table_data_elements;
      }

      this.showHideLoading();
    } else {
      this.showHideLoading();
    }
  },

  beforeDestroy() {
    sessionStorage.removeItem('createEditForm');
    sessionStorage.removeItem('editForm');
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
<style>
.el-table .cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
</style>
